<template>
  <div class="tabs-item" ref="wrapper">
    <div style="text-align: right">
      <el-button
      type="primary"
      size="small"
      @click="exportExcel"
      style="margin-bottom: 10px"
      >导出</el-button
    >
    <el-button
      slot="reference"
      size="small"
      type="primary"
      @click="tableVisible = true"
      >表格设置</el-button
    >
    </div>
    <el-table
      ref="table"
      border
      :data="tableData"
      :max-height="maxHeight"
      v-loading="tableData === null"
      highlight-current-row
      :row-class-name="rowClassNameMethod"
      @row-click="handleRowClick"
      v-if="tableReload"
    >
      <el-table-column
        :label="item.label"
        :prop="item.prop"
        :min-width="item.width"
        :sortable="item.sortable ? 'custom' : false"
        :align="item.align"
        :fixed="item.fixed"
        show-overflow-tooltip
        v-for="item in columnData"
        :key="item.prop"
      >
        <template slot-scope="scope">
          <template v-if="item.label == '图片'">
            <el-link
              type="primary"
              :underline="false"
              @click="showDialog(scope.row, 2)"
              v-if="showDetailBtn(scope.row)"
              >查看</el-link
            >
          </template>
          <template
            v-else-if="item.label == '产品编码' || item.lable == '产品名称'"
          >
            <remark :content="scope.row[item.prop]"></remark>
          </template>
          <template v-else-if="item.label == '缺货影响订单数'">
            <el-link
              :underline="false"
              type="success"
              @click="handleTabsChange(scope.row, 'orders')"
              >{{ scope.row.outOfStockOrders }}
            </el-link>
          </template>
          <template v-else-if="item.label == '缺货包件数'">
            <el-link
              :underline="false"
              type="success"
              @click="handleTabsChange(scope.row, 'packages')"
              >{{ scope.row.outOfStockPack }}
            </el-link>
          </template>
          <template v-else>
            {{ scope.row[item.prop] }}
          </template>
        </template>
      </el-table-column>
      <!-- <el-table-column fixed label="图片" width="80px">
        <template slot-scope="scope">
          <el-link type="primary" :underline="false" @click="showDialog(scope.row, 2)" v-if="showDetailBtn(scope.row)">查看</el-link>
        </template>
      </el-table-column>
      <el-table-column fixed label="产品编码" prop="productCode" width="120px">
        <template slot-scope="scope">
          <remark :content="scope.row.productCode"></remark>
        </template>
      </el-table-column>
      <el-table-column fixed label="产品名称" prop="productName" min-width="230px">
        <template slot-scope="scope">
          <remark :content="scope.row.productName"></remark>
        </template>
      </el-table-column>
      <el-table-column label="是否新品" prop="newTag" align="center" width="80px"></el-table-column>
      <el-table-column label="上市日期" prop="upTime" align="center" width="120px"></el-table-column>
      <el-table-column label="缺货记录天数" prop="countDurationDay" align="right" width="120px"></el-table-column>
      <el-table-column label="缺货量" prop="remainingAmount" align="right" width="120px"></el-table-column>
      <el-table-column label="缺货影响订单数" prop="outOfStockOrders" align="right" width="150px">
        <template slot-scope="scope">  
          <el-link :underline="false" type="success" @click="handleTabsChange(scope.row, 'orders')">{{
            scope.row.outOfStockOrders }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="缺货包件数" prop="outOfStockPack" align="right" width="120px">
        <template slot-scope="scope">  
          <el-link :underline="false" type="success" @click="handleTabsChange(scope.row, 'packages')">{{
            scope.row.outOfStockPack }}
          </el-link>
        </template>
      </el-table-column> -->
    </el-table>
    <div style="float: left; margin-top: 15px; color: #555555">
      <span>{{ timeText.updateContent ? '数据刷新时间：' : ''}}</span>
      <span>{{ timeText.latestUpdateTime ? timeText.latestUpdateTime : ''}}</span>
    </div>
    <div style="float:right; margin: 10px 0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationOpt.pageNum"
        :page-sizes="paginationOpt.pageSizes"
        :page-size="paginationOpt.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="paginationOpt.total"
      >
      </el-pagination>
    </div>

    <pic-video
      v-model="picVideoVisible"
      v-if="picVideoVisible"
      :data="rowData"
    ></pic-video>
    <custom-table
      v-model="tableVisible"
      :tableDataSet="tableDataSet"
      v-if="tableVisible"
      @closeAddForm="closeAddForm"
      @confirm="confirm"
    ></custom-table>
  </div>
</template>

<script>
import picVideoMin from "./pic&video.mixin";
import customProps from "./customProps.mixin";
export default {
  mixins: [picVideoMin, customProps],
  props: ["data","timeText"],
  data() {
    return {
      tableData: null,
      paginationOpt: {
        pageSizes: [30, 100, 500, 1000],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      activeRow: {},
    };
  },
  computed: {
    formData() {
      return this.data;
    },
    maxHeight() {
      let win_h = document.documentElement.clientHeight;
      return win_h - 368 + "px";
    },
  },
  activated() {
    this.getScroll();
  },
  mounted() {
    this.$refs.table.bodyWrapper.addEventListener(
      "scroll",
      (res) => {
        let height = res.target;
        this.scrollTop = height.scrollTop;
      },
      false
    );
    this.init();
  },
  deactivated() {
    this.$refs.table.bodyWrapper.removeEventListener(
      "scroll",
      (res) => {
        let height = res.target;
        this.scrollTop = height.scrollTop;
      },
      false
    );
  },
  methods: {
    getScroll() {
      setTimeout(() => {
        this.$el.querySelector(".el-table__body-wrapper").scrollTop =
          this.scrollTop;
      }, 10);
    },
    search() {
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    init() {
      this.tableData = null;
      let data = {
        filterData: {
          ...this.formData,
        },
        pageNum: this.paginationOpt.pageNum,
        pageSize: this.paginationOpt.pageSize,
      };
      this.$q.orderDate
        .deliveryOutOfStockProducts({ data: data })
        .then((res) => {
          if (res.success && res.data && res.data.records.length) {
            this.tableData = res.data.records;
            let paginationOpt = {
              total: res.data.total,
              pageNum: res.data.pageNum,
            };
            this.paginationOpt = { ...this.paginationOpt, ...paginationOpt };
          } else {
            this.tableData = [];
            let paginationOpt = {
              total: 0,
            };
            this.paginationOpt = { ...this.paginationOpt, ...paginationOpt };
          }
        });
    },
    handleTabsChange(row, tabName) {
      this.$emit("handleTabsChange", {
        formData: {
          productCode: row.productCode,
          outStockOrder: true,
        },
        tabName: tabName,
      });
    },
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init();
    },
    async exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let params = {
        taskDTO: {
          appCode: "ec-pc-new",
          paramMap: this.formData,
          reportName: "stockProductsExport",
        },
        columnDTOs: [],
      };
      let labels = this.columnData.map((v) => v.label);
      let props = this.columnData.map((v) => v.prop);
      props.forEach((prop, index) => {
        params.columnDTOs.push({
          columnName: labels[index],
          parentColumnName: null,
          fieldName: prop,
          fieldType: "string",
          columnFormat: null,
        });
      });
      // 不导出图片列
      params.columnDTOs = params.columnDTOs.filter(
        (v) => v.columnName !== "图片"
      );
      this.$q.common.customExportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success("提交下载任务成功，请稍后到导出列表查阅！");
        } else {
          this.$message.error(res.message);
        }
      }).finally(_=>{
        loading.close()
      });
    },
    rowClassNameMethod({ row, rowIndex }) {
      if (this.activeRow.productCode == row.productCode) {
        return "active-row";
      }
    },
    handleRowClick(row, column, event) {
      // console.log(row, column, event);
      this.activeRow = row;
    },
  },
  // activated() {
  //   // 不能用this.$nextTick，在页面渲染完成后滚动位置，会有一些偏差。设置定时器能确保table在渲染完成了再做滚动条的操作
  //   setTimeout(_=>{
  //     let tag = document.querySelector('.active-row');
  //     let content = document.querySelector('.el-table__body-wrapper');
  //     content.scrollTop = tag.offsetTop;
  //   },300)
  // }
};
</script>

<style lang="stylus" scoped>
.tabs-item {
  height: 100%;
}

>>> .active-row {
  background-color: #F1FAEE;
}
</style>
